export const exterior_view06ImageOptions = {
  angle: 'exterior_view06',
  staticOptions: {
    HullColorways: 1,
    BowSpirit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColorways',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC45/views/exterior_view06.js